import { supportalTypes } from "../actions/supportal";

const {
  SET_COUNTS,
  SET_FILTERED_USERS,
  SET_FILTER_BY,
  SET_FILTER_BY_ADDITIONAL_ACCOUNTS,
  SET_FILTER_BY_REASON,
  SET_ORDER_BY,
  SET_PAGE,
  SET_SEARCH_BY,
  SET_SORT_BY,
  SET_INCLUDE_TAGS,
  SET_EXCLUDE_TAGS,
  SET_FILTER_BY_MANUAL_REVIEW
} = supportalTypes;

const initialState = {
  filteredUsers: [],
  counts: {},
  page: 0,
  filterBy: "",
  searchBy: "",
  sortBy: "",
  orderBy: 0,
  filterByReason: "all",
  filterByAdditionalAccounts: false
};

export default function user(state = initialState, { type, payload }) {
  switch (type) {
    case SET_FILTERED_USERS:
    case SET_COUNTS:
    case SET_PAGE:
    case SET_FILTER_BY:
    case SET_SEARCH_BY:
    case SET_SORT_BY:
    case SET_ORDER_BY:
    case SET_FILTER_BY_REASON:
    case SET_FILTER_BY_ADDITIONAL_ACCOUNTS:
    case SET_INCLUDE_TAGS:
    case SET_EXCLUDE_TAGS:
    case SET_FILTER_BY_MANUAL_REVIEW:
      return { ...state, ...payload };
    default:
      return state;
  }
}
